import React from "react";
import DashboardBreadcrumbs from "components/DashboardBreadcrumbs";

export default function CountryLevelBreadcrumbs() {
  return (
    <DashboardBreadcrumbs aria-label="breadcrumb">Latam</DashboardBreadcrumbs>
  );
}
